import React from 'react'
import { Spinner } from 'reactstrap'
import EventIcon from '@material-ui/icons/Event'
import '../ActivityBoard.css'
import { formatActivityTimeRange, pickText } from './ViewUtils'

function DayBadge({ group, theme }) {
  return (
    <div className='ab-daybadge' style={{ background: theme.brand, color: theme.onBrand }}>
      <div className='ab-daybadge-long'>{group.weekdayLong.toUpperCase()}</div>
      <div className='ab-daybadge-abbr'>{group.weekdayShort.toUpperCase()}</div>
      <div className='ab-daybadge-date' style={{ color: theme.accent }}>
        {group.dayLabel}
      </div>
    </div>
  )
}

function EventCell({ activity, lang, href }) {
  const name = (pickText(activity.name, lang) || activity.displayName || '').replace(
    /Ryhmäliikunta \//gi,
    ''
  )
  const desc = pickText(activity.ingr, lang) || pickText(activity.ingress, lang)
  const body = (
    <>
      <div className='ab-name'>{name.toUpperCase()}</div>
      {desc ? <div className='ab-desc'>{desc}</div> : null}
    </>
  )
  // target=_top so a click escapes the iframe rather than loading the booking
  // app inside the host page's frame.
  return href ? (
    <a className='ab-rowlink' href={href} target='_top' rel='noopener noreferrer'>
      {body}
    </a>
  ) : (
    body
  )
}

function ActivityBoardView({
  mode,
  title,
  rangeLabel,
  groups,
  loading,
  theme,
  logo,
  unit,
  bodyWidth,
  lang,
  hrefFor,
  emptyText,
  rootRef,
}) {
  const tv = mode === 'tv'
  const rootStyle = {
    '--ab-unit': unit,
    '--ab-brand': theme.brand,
    '--ab-accent': theme.accent,
    '--ab-page': theme.page,
    '--ab-on-page': theme.onPage,
    '--ab-muted': theme.muted,
  }
  if (!tv) {
    rootStyle.maxWidth = bodyWidth
    rootStyle.margin = '0 auto'
  }

  let content
  if (loading) {
    content = (
      <div className='ab-empty'>
        <Spinner size='sm' color='secondary' />
      </div>
    )
  } else if (!groups || groups.length === 0) {
    content = <div className='ab-empty'>{emptyText}</div>
  } else {
    content = (
      <table className='ab-table'>
        <tbody>
          {groups.map((g) =>
            g.activities.map((a, i) => (
              <tr key={g.date + '.' + (a.id || i)}>
                {i === 0 ? (
                  <td className='ab-daycell' rowSpan={g.activities.length}>
                    <DayBadge group={g} theme={theme} />
                  </td>
                ) : null}
                <td className='ab-namecell'>
                  <EventCell activity={a} lang={lang} href={hrefFor ? hrefFor(a) : null} />
                </td>
                <td className='ab-timecell'>
                  <EventIcon className='ab-timeicon' style={{ color: theme.brand }} />
                  <div className='ab-timelabel' style={{ color: theme.muted }}>
                    AIKA
                  </div>
                  <div className='ab-time'>{formatActivityTimeRange(a)}</div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    )
  }

  return (
    <div
      ref={rootRef}
      className={'ab-root ' + (tv ? 'ab-tv' : 'ab-embed')}
      style={rootStyle}
    >
      <div className='ab-chevron ab-chevron-tr' />
      <div className='ab-chevron ab-chevron-br' />
      <header className='ab-header'>
        {logo.src ? <img className='ab-logo' src={logo.src} alt={logo.alt} /> : <span />}
        <h1 className='ab-title'>{title}</h1>
        <div className='ab-range' style={{ background: theme.accent, color: theme.onAccent }}>
          {rangeLabel}
        </div>
      </header>
      {content}
    </div>
  )
}

export default ActivityBoardView
